/**
 * コンテンツデータ編集画面のメインカラムに存在する各フィールドを取得します。
 *
 * - `mtappVars.contentDataFields`: このオブジェクトにはコンテンツフィールドのIDをキーとして、該当するフィールドのHTMLElementオブジェクトが格納されます。
 *   例：`mtappVars.contentDataFields.contentField1` でIDが1のコンテンツフィールドのHTMLElementオブジェクトにアクセスできます。
 *
 * - `mtappVars.contentDataFieldsArray`: この配列には、コンテンツフィールドのIDとそのフィールドのラベル名がオブジェクトとして格納されています。
 *   例：`[{ id: 1, name: 'フィールド名' }]`
 */
export function getContentDataFields() {
    if (window.mtappVars.mode !== 'view' && window.mtappVars.type !== 'content_data') {
        return;
    }

    const currentContentType = window.mtappVars.contentTypes.find((contentType) => contentType.id === window.mtappVars.content_type_id);

    window.mtappVars.contentDataFields = {};
    window.mtappVars.contentDataFieldsArray = [];

    const divs = document.querySelectorAll('#content_data > div');

    divs.forEach((div) => {
        let fieldId = 0;
        let contentField = div.querySelector(
            '[name^=content-field-], [name^=date-], [name^=time-], [name^=category-], [id^=asset-field-], [id^=content-type-field-]'
        );

        if (contentField) {
            const contentFieldName = contentField.name || contentField.id;
            if (contentFieldName) {
                const match = contentFieldName.match(/(content-field|date|time|category|asset-field|content-type-field)-(\d+).*/);
                if (match && match[2]) {
                    fieldId = parseInt(match[2], 10);
                }
            }
        }

        if (fieldId !== 0) {
            window.mtappVars.contentDataFields['contentField' + fieldId] = div;

            const currentField = currentContentType.fields.find((field) => field.id === fieldId);

            if (div.id) {
                div.classList.add('contentField' + fieldId);
            } else {
                div.id = 'contentField' + fieldId;
            }
            div.dataset.mtappFieldId = currentField.id;
            div.dataset.mtappFieldLabel = currentField.label;
            div.dataset.mtappFieldUid = currentField.unique_id;
            div.dataset.mtappFieldType = currentField.type;
            div.dataset.mtappFieldTypeLabel = currentField.type_label;

            window.mtappVars.contentDataFieldsArray.push({
                id: fieldId,
                name: currentField.label
            });
        } else if (div.id === 'data_label-field') {
            window.mtappVars.contentDataFields['dataLabelField'] = div;
        }
    });
}
